var _g, _g2, _rect, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoals330(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 105,
    viewBox: "0 0 168 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_131_277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.07 60.36C58.11 60.36 56.39 59.95 54.91 59.13C53.43 58.31 52.28 57.1 51.46 55.5C50.66 53.9 50.26 51.92 50.26 49.56C50.26 47.24 50.66 45.26 51.46 43.62C52.28 41.96 53.45 40.7 54.97 39.84C56.49 38.96 58.32 38.52 60.46 38.52C61.62 38.52 62.82 38.65 64.06 38.91C65.32 39.17 66.59 39.57 67.87 40.11L67.57 45.48H65.02L64.3 42L64.96 42.6C64.26 42.36 63.55 42.17 62.83 42.03C62.11 41.87 61.43 41.79 60.79 41.79C59.55 41.79 58.49 42.08 57.61 42.66C56.73 43.24 56.05 44.1 55.57 45.24C55.11 46.38 54.88 47.8 54.88 49.5C54.88 51.86 55.36 53.71 56.32 55.05C57.3 56.39 58.72 57.06 60.58 57.06C61.14 57.06 61.73 57 62.35 56.88C62.97 56.74 63.61 56.55 64.27 56.31L63.76 57.21V51.51L64.45 52.26L61.57 51.69V49.47L69.91 49.32V51.57L67.33 52.26L67.75 51.51V58.68C66.37 59.24 65.03 59.66 63.73 59.94C62.43 60.22 61.21 60.36 60.07 60.36ZM79.4718 43.62C81.8318 43.62 83.6718 44.32 84.9918 45.72C86.3118 47.12 86.9718 49.11 86.9718 51.69C86.9718 53.49 86.6518 55.04 86.0118 56.34C85.3718 57.62 84.4518 58.61 83.2518 59.31C82.0518 60.01 80.6118 60.36 78.9318 60.36C76.5718 60.36 74.7418 59.66 73.4418 58.26C72.1618 56.86 71.5218 54.87 71.5218 52.29C71.5218 50.49 71.8318 48.95 72.4518 47.67C73.0918 46.37 74.0018 45.37 75.1818 44.67C76.3618 43.97 77.7918 43.62 79.4718 43.62ZM79.2618 46.62C78.1218 46.62 77.2718 47.07 76.7118 47.97C76.1518 48.85 75.8718 50.22 75.8718 52.08C75.8718 53.94 76.1418 55.29 76.6818 56.13C77.2218 56.95 78.0418 57.36 79.1418 57.36C79.9418 57.36 80.5918 57.16 81.0918 56.76C81.5918 56.36 81.9718 55.75 82.2318 54.93C82.4918 54.11 82.6218 53.1 82.6218 51.9C82.6218 50.08 82.3418 48.75 81.7818 47.91C81.2218 47.05 80.3818 46.62 79.2618 46.62ZM102.366 57.87L101.796 57.03L104.376 57.84V59.97L99.1263 60.24L98.5563 57.36L98.8563 57.45C98.0563 58.43 97.1863 59.16 96.2463 59.64C95.3063 60.12 94.3363 60.36 93.3363 60.36C92.0563 60.36 90.9963 59.95 90.1563 59.13C89.3163 58.31 88.8962 57.13 88.8962 55.59C88.8962 54.45 89.1363 53.55 89.6163 52.89C90.1163 52.21 90.8363 51.72 91.7763 51.42C92.7163 51.12 93.8563 50.97 95.1963 50.97H98.4663L98.1663 51.3V49.32C98.1663 48.38 97.9363 47.71 97.4763 47.31C97.0363 46.91 96.3863 46.71 95.5263 46.71C95.1063 46.71 94.6563 46.75 94.1763 46.83C93.6963 46.91 93.1763 47.03 92.6163 47.19L93.0363 46.74L92.6463 49.17H90.0363L89.7963 44.79C91.1563 44.39 92.3963 44.1 93.5163 43.92C94.6563 43.72 95.6963 43.62 96.6363 43.62C98.4963 43.62 99.9163 44.02 100.896 44.82C101.876 45.62 102.366 46.86 102.366 48.54V57.87ZM93.1263 55.17C93.1263 55.91 93.2963 56.46 93.6363 56.82C93.9963 57.16 94.4463 57.33 94.9863 57.33C95.4863 57.33 96.0363 57.18 96.6363 56.88C97.2363 56.56 97.8063 56.13 98.3463 55.59L98.1663 56.31V52.89L98.4663 53.19H95.8863C94.8463 53.19 94.1263 53.35 93.7263 53.67C93.3263 53.99 93.1263 54.49 93.1263 55.17ZM111.383 57.54L111.083 57.18L113.393 57.84V60H105.203V57.84L107.513 57.18L107.183 57.54V39.39L107.453 39.69L105.203 39.06V36.9L111.383 36.66V57.54ZM119.353 48.03C119.353 48.49 119.553 48.86 119.953 49.14C120.353 49.42 120.863 49.66 121.483 49.86C122.123 50.06 122.793 50.27 123.493 50.49C124.213 50.71 124.883 51 125.503 51.36C126.143 51.7 126.663 52.16 127.063 52.74C127.463 53.32 127.663 54.07 127.663 54.99C127.663 56.17 127.343 57.16 126.703 57.96C126.063 58.76 125.193 59.36 124.093 59.76C122.993 60.16 121.753 60.36 120.373 60.36C119.573 60.36 118.723 60.29 117.823 60.15C116.943 60.01 116.033 59.82 115.093 59.58L115.273 55.05H117.913L118.243 57.69L117.883 57.18C118.283 57.3 118.723 57.4 119.203 57.48C119.683 57.54 120.103 57.57 120.463 57.57C120.983 57.57 121.463 57.5 121.903 57.36C122.363 57.22 122.733 57.02 123.013 56.76C123.313 56.48 123.463 56.13 123.463 55.71C123.463 55.23 123.263 54.85 122.863 54.57C122.463 54.29 121.943 54.05 121.303 53.85C120.683 53.65 120.023 53.44 119.323 53.22C118.643 53 117.983 52.71 117.343 52.35C116.723 51.99 116.213 51.51 115.813 50.91C115.413 50.31 115.213 49.53 115.213 48.57C115.213 47.41 115.503 46.47 116.083 45.75C116.663 45.01 117.433 44.47 118.393 44.13C119.373 43.79 120.443 43.62 121.603 43.62C122.423 43.62 123.293 43.7 124.213 43.86C125.133 44 126.073 44.21 127.033 44.49L126.883 48.51H124.213L123.733 46.14L124.303 46.77C123.363 46.51 122.533 46.38 121.813 46.38C121.073 46.38 120.473 46.53 120.013 46.83C119.573 47.11 119.353 47.51 119.353 48.03Z",
    fill: "#3F3F3F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_131_277)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 42H43.2V38.8H40V42ZM39.2 42H36V38.8H39.2V42ZM35.2 42H32V38.8H35.2V42ZM31.2 42V38.8H24C13.3961 38.8 4.8 47.3961 4.8 58C4.8 68.6039 13.3961 77.2 24 77.2C34.6039 77.2 43.2 68.6039 43.2 58V50.8H40V58C40 66.8366 32.8366 74 24 74C15.1634 74 8 66.8366 8 58C8 49.1634 15.1634 42 24 42H31.2ZM40 50H43.2V46.8H40V50ZM39.2 50.8V58C39.2 66.3947 32.3947 73.2 24 73.2C15.6053 73.2 8.8 66.3947 8.8 58C8.8 49.6053 15.6053 42.8 24 42.8H31.2V46H24C17.3726 46 12 51.3726 12 58C12 64.6274 17.3726 70 24 70C30.6274 70 36 64.6274 36 58V50.8H39.2ZM35.2 46H32V42.8H35.2V46ZM36 42.8V46H39.2V42.8H36ZM36 46.8V50H39.2V46.8H36ZM35.2 58V50.8H32V58C32 62.4183 28.4183 66 24 66C19.5817 66 16 62.4183 16 58C16 53.5817 19.5817 50 24 50H31.2V46.8H24C17.8144 46.8 12.8 51.8144 12.8 58C12.8 64.1856 17.8144 69.2 24 69.2C30.1856 69.2 35.2 64.1856 35.2 58ZM31.2 58C31.2 61.9764 27.9764 65.2 24 65.2C20.0236 65.2 16.8 61.9764 16.8 58C16.8 54.0236 20.0236 50.8 24 50.8H31.2V58ZM32 50V46.8H35.2V50H32ZM40 46H43.2V42.8H40V46Z",
    fill: "#3F3F3F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 78,
    width: 80,
    height: 1,
    transform: "rotate(-180 129 78)",
    fill: "#3F3F3F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 73,
    width: 80,
    height: 1,
    transform: "rotate(-180 129 73)",
    fill: "#3F3F3F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 68,
    width: 80,
    height: 1,
    transform: "rotate(-180 129 68)",
    fill: "#3F3F3F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_131_277",
    x: 10.26,
    y: 0.660156,
    width: 157.403,
    height: 103.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_277",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_131_277",
    x: 0.800049,
    y: 38.7998,
    width: 46.3999,
    height: 46.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_277",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals330);
export default __webpack_public_path__ + "static/media/Goals330.3829da0e2710027abc7305d7578e5c31.svg";
export { ForwardRef as ReactComponent };